<template>
  <div class="protocol">
    <img src="../../assets/image/protocol/one.png" alt="">
    <img src="../../assets/image/protocol/two.png" alt="">
    <img src="../../assets/image/protocol/three.png" alt="">
    <img src="../../assets/image/protocol/four.png" alt="">
  </div>
</template>

<script>
export default {
  name: 'Protocol',
  components: {},
  data () {
    return {}
  },
  methods: {}
}
</script>
<style scoped lang="less">
@media (max-width: 980px) {
  .protocol {
    img {
      width: 100%;
      margin: 0;
      display: block;
    }
  }

}
@media (min-width: 981px) {
  .protocol {
    display: none;
  }
}
</style>
